package user.service

import antd.message.message
import com.jingfangpai.common.json.json
import com.jingfangpai.api.base.JWT_SESSIONSTORAGE_KEY
import com.jingfangpai.user.model.UserAuthData
import kotlinx.browser.localStorage
import kotlinx.serialization.json.Json
import org.jooq.PermissionType

object AuthService {

    const val USER_AUTH_DATA_SESSIONSTORAGE_KEY = "UserAuthData"

    /**
     * 设置登录用户信息
     */
    fun setUserAuthData(memberAuthData: UserAuthData?, jwt:String){
        localStorage.setItem(JWT_SESSIONSTORAGE_KEY,jwt)
        memberAuthData?.let{ it->
            localStorage.setItem(USER_AUTH_DATA_SESSIONSTORAGE_KEY, Json.encodeToString(UserAuthData.serializer(),it))
        }
    }

    fun removeAuthData(){
        localStorage.removeItem(JWT_SESSIONSTORAGE_KEY)
        localStorage.removeItem(USER_AUTH_DATA_SESSIONSTORAGE_KEY)
    }

    /**
     * 获取成员信息
     */
    fun getUserAuthData():UserAuthData?{
        val userAuthDataStr = localStorage.getItem(USER_AUTH_DATA_SESSIONSTORAGE_KEY)
        var userAuthData: UserAuthData? = null
        if(!userAuthDataStr.isNullOrBlank()){
            try {
                userAuthData = json.decodeFromString(
                    UserAuthData.serializer(), userAuthDataStr!!
                )
            }catch (e:Throwable){
                message.error("出错了，您可能需要重新登录");
            }
        }
        return userAuthData
    }

    /**
     * 获取登录者权限列表
     */
    fun getUserPermissions():Array<PermissionType>{
        return getUserAuthData()?.getPermissions()?:arrayOf();
    }

    /**
     * 获取机构Id
     */
    fun getOrganizationId():String?{
        val userAuthDataStr = localStorage.getItem(USER_AUTH_DATA_SESSIONSTORAGE_KEY)
        var organizationId: String? = null
        if(!userAuthDataStr.isNullOrBlank()){
            try {
                val memberAuthData = json.decodeFromString(
                    UserAuthData.serializer(),
                    userAuthDataStr
                )
                organizationId = memberAuthData.organizationId
            }catch (e:Throwable){
                message.error("出错了，您可能需要重新登录");
            }
        }
        return organizationId
    }

}
